import clsx from "clsx"

import { labelSizeMap } from "./config"
import { getButtonClasses } from "./style-react"
import type { BaseButtonProps } from "./types"
import { Label } from "../../Typography/Label/Label.react"

/**
 * **Props**:
 * - `text`: string
 * - `size`: "small" | "medium" | "large"
 * - `variant`: "primary" | "secondary" | "tertiary" | "destructive"
 * - `disabled`: boolean
 * - `onPress`: function
 *
 * See also: {@link BaseButtonProps}
 */
export const BaseButton = (props: BaseButtonProps) => {
  const { as, children, text, size, className, testId, LeftIcon, RightIcon, onPress, contentInvisible, ...rest } = props
  const Component = as

  const c = getButtonClasses({ contentInvisible, ...props })

  return (
    <Component
      className={clsx(c.container, className)}
      data-testid={testId}
      onClick={onPress}
      {...rest} // 💅
    >
      {!!LeftIcon && <LeftIcon className={c.icon} />}

      <Label className={c.text} size={labelSizeMap[size]} numberOfLines={1}>
        {text}
      </Label>

      {!!RightIcon && <RightIcon className={c.icon} />}

      {children}
    </Component>
  )
}
